import { API_URL } from "../../config/connect";

export async function getAdContent(adTitle, langCode = 'ru') {
    const endpoint = `${API_URL}/api/v1/ai/ad-content`;

    try {
        const accessToken = localStorage.getItem("access_token");
        if (!accessToken) {
            throw new Error("Access token is missing");
        }

        const response = await fetch(endpoint, {
            method: 'POST',
            headers: {
                'Authorization': `Bearer ${accessToken}`,
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                ad_title: adTitle,
                lang_code: langCode
            })
        });

        if (!response.ok) {
            throw new Error(`Error: ${response.statusText}`);
        }

        const result = await response.json();
        return result;
    } catch (error) {
        console.error('Failed to get AI ad content:', error);
        throw error;
    }
}


















